import React, { useEffect, useState } from 'react';
import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/20/solid'
import { PhoneIcon, EnvelopeIcon, ChartBarIcon, PlusIcon, CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline'
import Swal from 'sweetalert2';

import LeadsService from '@/services/LeadsService';

export default function LeadsStats() {

  const [stats, setStats] = useState([
    { id: 1, name: 'Loading...', stat: '', icon: ChartBarIcon },
    { id: 2, name: 'Loading...', stat: '', icon: PlusIcon },
    { id: 3, name: 'Loading...', stat: '', icon: CheckCircleIcon },
    { id: 4, name: 'Loading...', stat: '', icon: XCircleIcon },
  ]);


  useEffect(() => {
    async function fetchStats() {
      let statsResponse = await LeadsService.getLeadStats();
      if (statsResponse.error) {
        console.error('Failed to load leads stats:', statsResponse.error);
        Swal.fire('Error', statsResponse.error, 'error');
        return;
      }
      setStats([
        {id: 1, name: 'Total leads', stat: statsResponse.data.statTotal, icon: ChartBarIcon},
        {id: 2, name: 'New leads', stat: statsResponse.data.statNew, icon: PlusIcon},
        {id: 3, name: 'Won leads', stat: statsResponse.data.statWon, icon: CheckCircleIcon},
        {id: 4, name: 'Lost leads', stat: statsResponse.data.statLost, icon: XCircleIcon},
      ]);
    }
    fetchStats();
  }, []);

  return (
    <div className='mb-3'>
      <dl className="mt-2 mb-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((item) => (
          <div
            key={item.id}
            className="relative overflow-hidden rounded-lg bg-white px-4 pt-4 pb-3 shadow-sm sm:px-9 sm:pt-4"
          >
            <dt className="flex items-center justify-between">
              <div className="flex items-center">
                <div className="absolute rounded-md bg-indigo-500 p-3 mt-1">
                  <item.icon aria-hidden="true" className="size-3 text-white" />
                </div>
                <p className="ml-16 truncate text-md font-medium text-gray-500">{item.name}</p>
              </div>
              <p className="text-2xl font-semibold text-gray-900">{item.stat}</p>
            </dt>
            <dd className="ml-16 flex items-baseline pb-6 sm:pb-3 sm:pt-1">
              <div className="absolute inset-x-0 bottom-0 bg-gray-50 px-4 py-2 sm:px-6">
                <div className="text-sm"></div>
              </div>
            </dd>
          </div>
        ))}
      </dl>
    </div>
  )
}
